module.exports = __webpack_public_path__ + "img/mercedes-eqc-4-top.32a9d4cb.jpg";